import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

import classNames from 'clsx';
import { FormattedMessage, useIntl } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';
import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { Tooltip } from 'ui-components/components/tooltip';
import { TOOL_TIP_POSITIONS } from 'ui-components/services/tooltip-service';

import { messages } from './messages';
import styles from './tax-identifier-section.module.css';
import { useTaxFormContext } from '../../context/tax-form-context-provider';
import { useTaxIdConfig } from '../../hooks/use-tax-id-config';
import { TaxIdentifierForm } from '../tax-identifier-form/tax-identifier-form';

/**
 * @param {object} props
 * @param {string} [props.className] - Optional CSS class name for the wrapper
 * @param {string} [props.sectionClassName] - Optional CSS class name for the form section container
 * @param {string} [props.formClassName] - Optional CSS class name for the form
 * @returns {JSX.Element}
 */
export const TaxIdentifierSection = ({ className, sectionClassName, formClassName }) => {
  const intl = useIntl();
  const taxIdConfig = useTaxIdConfig();
  const { isVisibleForPaymentFlow } = taxIdConfig;
  const { isTaxSectionOpen, setIsTaxSectionOpen } = useTaxFormContext();

  if (!isVisibleForPaymentFlow) {
    return <></>;
  }

  return (
    <FlexColumn className={classNames(styles.wrapper, className)} gap={Gap.Space8}>
      <FlexRow gap={Gap.Space8}>
        <Checkbox
          checked={isTaxSectionOpen}
          className={styles.checkbox}
          label={intl.formatMessage(messages.taxIdentifierCheckboxLabel)}
          onChange={setIsTaxSectionOpen}
        />
        <Tooltip position={TOOL_TIP_POSITIONS.bottom} text={<FormattedMessage {...messages.taxInformationTooltip} />}>
          <div>
            <FontAwesomeIcon className={styles.tooltip} icon={faInfoCircle} />
          </div>
        </Tooltip>
      </FlexRow>
      {isTaxSectionOpen ? (
        <section className={sectionClassName}>
          <Text element='span' textType={TextType.H2} value={messages.header} />
          <TaxIdentifierForm className={formClassName} />
        </section>
      ) : null}
    </FlexColumn>
  );
};
